import './App.css';
import { BrowserRouter, Routes, Route } from "react-router";
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home/Home.js';
import Error from './pages/404Page/404Page'
import Header from './components/Header/Header';
import PrivacyPolicy from './pages/Legal/PrivacyPolicy';
import TermsConditions from './pages/Legal/TermsConditions';
import CookiePolicy from './pages/Legal/CookiePolicy';
import Contact from './pages/Home/Contact/Contact.js';
import GetApp from './pages/GetApp/GetApp.js';
import Explore from './pages/Explore/Explore.js';
import MealDetail from './pages/MealDetail/MealDetail.js';
import PerformanceMonitor from './components/SEO/PerformanceMonitor';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA8wxx0Flf3peYfyDuebcrJmV1nH_bpYRY",
  authDomain: "meal-planner-a4500.firebaseapp.com",
  projectId: "meal-planner-a4500",
  storageBucket: "meal-planner-a4500.appspot.com",
  messagingSenderId: "652462822288",
  appId: "1:652462822288:web:50a8c1a58e7fdec125d915",
  measurementId: "G-3Z2LEXD9TD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

function App() {

  return (
    <HelmetProvider>
      <PerformanceMonitor />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Header />}>
            <Route path="/" element={<Home />} />
            <Route path="explore" element={<Explore />} />
            <Route path="meal/:mealSlug" element={<MealDetail />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="terms-and-conditions" element={<TermsConditions />} />
            <Route path="cookie-policy" element={<CookiePolicy />} />
            <Route path="contact-us" element={<Contact />} />
            <Route path="get" element={<GetApp />} />
            <Route path="*" element={<Error />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
